import { render, staticRenderFns } from "./GeneralInformationForm.vue?vue&type=template&id=24009bc0&scoped=true&"
import script from "./GeneralInformationForm.vue?vue&type=script&lang=ts&"
export * from "./GeneralInformationForm.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralInformationForm.vue?vue&type=style&index=0&id=24009bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24009bc0",
  null
  
)

export default component.exports